"use strict";var e=require("lodash.debounce"),r=require("react");exports.useDebounce=(u,c=500)=>{const s=r.useRef(u);r.useEffect((()=>{s.current=u}),[u]);const t=r.useMemo((()=>e(((...e)=>s.current(...e)),c)),[c]);return r.useEffect((()=>()=>{t.cancel()}),[t]),t};
//# sourceMappingURL=useDebounce.js.map
